import type { LocalLibraryStore } from "./localStore";
import type { RemoteLibrary } from "./remote";

export interface SyncReport {
  pushed: number;
  pulled: number;
}

/**
 * Mismo algoritmo que LibrarySyncer en Android:
 * 1. push de lo pendiente (incluidos borrados) y se marca como confirmado;
 * 2. pull incremental desde el ultimo cursor con last-write-wins;
 * 3. limpieza de tombstones ya confirmados.
 */
export async function syncLibrary(local: LocalLibraryStore, remote: RemoteLibrary): Promise<SyncReport> {
  // Se envia una copia sin el flag local `pending`.
  const { library, progress } = local.pending();
  const libraryOut = library.map(({ pending: _pending, ...entry }) => entry);
  const progressOut = progress.map(({ pending: _pending, ...row }) => row);
  await remote.pushLibrary(libraryOut);
  await remote.pushProgress(progressOut);
  local.markSynced(libraryOut, progressOut);

  const cursors = local.cursors();
  const [libraryPage, progressPage] = await Promise.all([remote.pullLibrary(cursors.library), remote.pullProgress(cursors.progress)]);
  const pulled = local.applyRemote(libraryPage.records, progressPage.records, {
    library: libraryPage.cursor,
    progress: progressPage.cursor,
  });

  local.purgeSyncedTombstones();
  return { pushed: libraryOut.length + progressOut.length, pulled };
}
